import { queryOptions } from "@tanstack/react-query";
import sortBy from "lodash-es/sortBy";

import {
  create,
  createReport,
  getCommodities,
  getLanguages,
  getReport,
  putReport,
  ReportUpdateTo,
} from "@/generated/api/news";

const commoditiesQuery = () => {
  return queryOptions({
    queryFn: ({ signal }) => getCommodities({ signal }),
    queryKey: ["commodities"],
  });
};

const languagesQuery = () => {
  return queryOptions({
    queryFn: ({ signal }) => getLanguages({ signal }),
    queryKey: ["languages"],
    select: (data) => sortBy(data, (language) => language.localName),
  });
};

const reportQuery = (id: string) => {
  return queryOptions({
    queryFn: ({ signal }) => getReport(parseInt(id), { signal }),
    queryKey: ["report", id],
  });
};

const uploadImage = async (image: File | Blob) => {
  const formData = new FormData();
  formData.append("file", image);
  // @ts-expect-error types from swagger are actually wrong
  return await create(formData);
};

const reportCreateMutation = () => {
  return {
    mutationFn: (payload: ReportUpdateTo) => createReport(payload),
  };
};

const reportUpdateMutation = () => {
  return {
    mutationFn: ({ id, ...payload }: ReportUpdateTo & { id: number }) =>
      putReport(id, payload),
  };
};

export {
  commoditiesQuery,
  languagesQuery,
  reportCreateMutation,
  reportQuery,
  reportUpdateMutation,
  uploadImage,
};
